import React from "react";
import VehiclesListItem from "../VehiclesListItem/VehiclesListItem";
import "./VehiclesList.sass";

const VehiclesList = ({ list, handleListItemClick }) => {
  return (
    <div className="vehicle-list">
      {/* <div class="icon-scroll"></div> */}

      {list.map((item, index) => {
        return (
          <VehiclesListItem
            model={item}
            handleListItemClick={handleListItemClick}
          />
        );
      })}
    </div>
  );
};

export default VehiclesList;
